import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum pageTypeEnum {
  report = 0,
  feedback = 1,
}

export enum centerPageTypeEnum {
  report = 1,
  violation,
  publish,
}
export interface ReportParamsInterface {
  mid?: number
  target_mid?: number
  room_id?: number
  reason?: number
  text?: string
  type?: string
  image_data?: string[]
  image_urls?: string[]
  content?: string
  app_version?: string
  h_did?: string
  device_model?: string
  fid?: number
}

interface ImgUrlSt {
  w: number
  h: number
  urls: Array<string>
}
interface PostImgUrl {
  aspect_low: ImgUrlSt
  origin: ImgUrlSt
}

interface PostST {
  ct: number
  duration_str: string
  image_urls: Array<PostImgUrl>
  member: any
  fid: number
  text: string
}

interface FeedST {
  post: PostST
  type: number
  debug: string
}

// 举报文案配置 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92453989
export const report_config = createAsyncThunk(
  'FeedBack_report_config',
  async (arg: any, store: any) => {
    const {biz_from} = store.getState().FeedBack
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'list' | 'list_v2' | 'nickname' | 'room_title' | 'feed_nickname'
        >
      >
    >(
      '/live/misc/report_config',
      {
        ...store.getState().env.deviceinfo,
        biz_from,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获取聊天记录
export const chat_history = createAsyncThunk(
  'FeedBack_chat_history_list',
  async (arg: any, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        list: Array<{type: number; msg: string; url?: string}>
        target_member: any
      }>
    >('/live/misc/chat_history_list', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// 获取动态记录
export const feed_history = createAsyncThunk(
  'FeedBack_feed_list',
  async (arg: any, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        list: Array<FeedST>
        offset: number
        more: boolean
      }>
    >('/live/feed/user_feed_list', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// 获取举报视频陪聊反馈截图
export const get_screenshot = createAsyncThunk(
  'FeedBack_get_screenshot',
  async (arg: any, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        urls: Array<string>
      }>
    >('/live/facetime/get_screenshot', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// 获取举报历史

interface InitialStateType {
  biz_from: pageTypeEnum
  content?: string // 聊天信息
  list?: Array<{msg: string; reason: number}>
  list_v2?: Array<{
    msg: string
    report_type: number
    list: Array<{msg: string; reason: number}>
  }>
  nickname?: string
  room_title?: string
  feed_nickname?: string
  facetime_target_mid?: number
  chat_list?: {
    list?: Array<{
      msgid: number
      type: number
      msg: string
      status?: number
      url?: string
    }>
    target_member?: any
  }
  feed_list: {
    list?: Array<FeedST>
    offset?: number
    more?: boolean
  }
  video_screen?: Array<string>
}

const initialState: InitialStateType = {
  // 默认为0 也就是上报页面
  biz_from: pageTypeEnum.report,
  feed_list: {},
  chat_list: {},
}

export const FeedBackSlice = createSlice({
  name: 'FeedBack',
  initialState,
  reducers: {
    setBizFrom: (state, action: PayloadAction<pageTypeEnum>) => {
      Object.assign(state, {
        biz_from: action.payload,
      })
    },
    // 聊天信息
    setContent: (state, action: PayloadAction<string>) => {
      Object.assign(state, {
        content: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(report_config.fulfilled, (state, action) => {
      const {list = [], list_v2 = []} = action.payload
      Object.assign(state, action.payload, {list, list_v2})
    })
    builder.addCase(chat_history.fulfilled, (state, action) => {
      const {list, target_member} = action.payload
      const {content} = state
      const list_v1 = list?.map((item) => ({
        ...item,
        status:
          (item.msg === content ? 1 : 0) || (item?.url === content ? 1 : 0),
      }))
      Object.assign(state.chat_list, {list: list_v1, target_member})
    })
    builder.addCase(feed_history.fulfilled, (state, action) => {
      Object.assign(state.feed_list, {...action.payload})
    })
    // 视频截图
    builder.addCase(get_screenshot.fulfilled, (state, action) => {
      Object.assign(state, {video_screen: action.payload.urls})
    })
  },
})
export default FeedBackSlice.reducer
export const FeedBackActions = FeedBackSlice.actions
